module.exports = __webpack_public_path__ + "img/bottomSteps2new.93bb2888.png";